import React from 'react';
import { TAG } from 'shared/constants';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { useTheme } from 'styled-components';
import { pwaStyleAdapter } from '../../../utils/mobileSupported';
import LazyImage from '../../LazyImage/LazyImage';

const Divider = () => {
  const { BottomBar } = useTheme();

  return (
    <LazyImage
      tag={TAG.IMG}
      alt="divider"
      src={assetSource(ASSET_KEY.BOTTOM_BAR_DIVIDER)}
      style={pwaStyleAdapter(BottomBar.Divider)}
    />
  );
};

export default Divider;

